// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const grotle: PokeData = {
  "id": 388,
  "name": "grotle",
  "height": 11,
  "weight": 970,
  "base_experience": 142,
  "types": [
    PokeType.GRASS
  ],
  "api_moves": [
    "tackle",
    "double-edge",
    "bite",
    "absorb",
    "mega-drain",
    "leech-seed",
    "growth",
    "razor-leaf",
    "sleep-powder",
    "withdraw",
    "curse",
    "giga-drain",
    "synthesis",
    "crunch",
    "leaf-blade",
    "leaf-storm",
    "bulldoze",
    "leafage"
  ],
  "moves": [
    "tackle",
    "bite",
    "razor-leaf",
    "curse",
    "synthesis",
    "crunch",
    "overgrowth",
    "vine-whip",
    "energy-ball",
    "flower-rush",
    "bullet-seed",
    "wood-hammer",
    "power-whip"
  ],
  "evolution_chain": {
    "id": 203,
    "item": null,
    "species": [
      {
        "name": "turtwig",
        "order": 417,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "grotle",
        "order": 418,
        "types": [
          PokeType.GRASS
        ],
        "evolves_from_species_id": 387,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "torterra",
        "order": 419,
        "types": [
          PokeType.GRASS,
          PokeType.GROUND
        ],
        "evolves_from_species_id": 388,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 32,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 75,
    "speed": 36,
    "ability_power": 89
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
